export default __webpack_public_path__ + "static/media/panda.23b4bea7941a74bd64e8e91ee8176328.png";